import styled from 'styled-components'

export const Container = styled.div`
    background: #fff;
    /* margin-top: 30px; */
    padding-top: 40px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    /* align-items: center; */
    justify-content: center;
    height: 100%;
`

export const Content = styled.div`
    max-width: 450px;
    /* min-width: 400px; */
`

export const Title = styled.div`
    margin-bottom: 30px;

    .key {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 16px;

        span {
            display: inline-flex;
            background: rgba(59, 174, 91, 0.1);
            padding: 6px;
            border-radius: 50%;
        }
        span.background {
            background: rgba(59, 174, 91, 0.05);
            display: inline-flex;

            padding: 7px;
            border-radius: 50%;
        }
    }

    h1 {
        /* font-family: 'Inter'; */
        text-align: center;
    }

    h3 {
        /* font-family: 'Inter'; */
    }
`
export const Form = styled.form`
    .field:first-child {
        margin-bottom: 10px;
    }
    .actions {
        margin-top: 15px;
    }
`
export const Back = styled.div`
    margin-top: 30px;
    display: flex;
    justify-content: center;

    a {
        display: flex;
        align-items: center;
        gap: 6px;
    }
`
